"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateMaskValues = exports.lowerCaseList = void 0;
const constants_1 = require("./constants");
const lowerCaseList = (list) => list.map((item) => item.toLowerCase());
exports.lowerCaseList = lowerCaseList;
const mutateMaskValues = ({ log, mask, whiteList, blackList, maskText, maskNestedLevel = 0 }) => {
    Object.keys(log).forEach(key => {
        // masks pii value if key satisfies requirements
        if (blackList.includes(key.toLowerCase()) ||
            (constants_1.piiMasks[mask].includes(key.toLowerCase()) &&
                !whiteList.includes(key.toLowerCase()))) {
            log[key] = maskText;
        }
        // recursive step to go within object
        if (maskNestedLevel > 0 && typeof log[key] === 'object' && log[key] !== null) {
            (0, exports.mutateMaskValues)({
                log: log[key],
                mask,
                whiteList,
                blackList,
                maskText,
                maskNestedLevel: maskNestedLevel - 1,
            });
        }
    });
};
exports.mutateMaskValues = mutateMaskValues;
//# sourceMappingURL=utils.js.map